<script>
const LS_PICNIC_TOUCH = 'picnic-team-touch-device'
const LISTENER_TOUCH = 'touchstart'

export default {
  name: 'DetectTouch',
  created() {
    this.detectTouch()
  },
  render() {
    return null
  },
  methods: {
    detectTouch() {
      window.addEventListener(LISTENER_TOUCH, this.handleTouch, false)
    },

    handleTouch() {
      // or set your app's state however you normally would
      this.$emit('touch-detected')
      // we only need to know once that a human touched the screen, so we can stop listening now
      window.removeEventListener(LISTENER_TOUCH, this.handleTouch, false)
    }
  }
}
</script>
